module.exports = __webpack_public_path__ + "media/images/admin/icons/italic-b9ef9040fc4d2104b5dab5e8130def31.svg";